import type { TableFooterProps, TableRowData } from '../types';
import { PaginationFooter } from './PaginationFooter';

/**
 * Table footer with pagination controls
 * Uses context to access table instance and query state
 */
export function TableFooter<TRow extends TableRowData>({
  pageSizeOptions,
  table,
  paginationState,
  onPageChange,
  onPageSizeChange,
}: TableFooterProps<TRow>) {
  return (
    <PaginationFooter
      pageIndex={paginationState.pageIndex}
      pageSize={paginationState.pageSize}
      totalRows={table.getRowCount()}
      totalPages={table.getPageCount()}
      canPreviousPage={table.getCanPreviousPage()}
      canNextPage={table.getCanNextPage()}
      pageSizeOptions={pageSizeOptions}
      onPageChange={onPageChange}
      onPageSizeChange={onPageSizeChange}
    />
  );
}
